
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 140072"}},[_c('g',{attrs:{"data-name":"Beaming Face with Smiling Eyes"}},[_c('circle',{attrs:{"data-name":"Ellipse 6573","cx":"14.02","cy":"14.02","fill":"#fdca47","r":"14.02","transform":"translate(1.229 1.126)"}}),_c('path',{attrs:{"data-name":"Path 154733","d":"M9.633 18.147a1.306 1.306 0 00-1.519 1.647 7.432 7.432 0 0014.268 0 1.306 1.306 0 00-1.519-1.647 27.618 27.618 0 01-11.23 0z","fill":"#664100"}}),_c('g',{attrs:{"data-name":"Group 139897"}},[_c('path',{attrs:{"data-name":"Path 154736","d":"M16.858 15.115a.705.705 0 01-.684-.875c.419-1.688 1.594-2.823 2.923-2.823s2.5 1.134 2.924 2.823a.705.705 0 11-1.368.34c-.256-1.032-.9-1.752-1.556-1.752s-1.3.721-1.555 1.753a.705.705 0 01-.684.534z","fill":"#664100"}})]),_c('g',{attrs:{"data-name":"Group 139898"}},[_c('path',{attrs:{"data-name":"Path 154737","d":"M9.161 15.115a.705.705 0 01-.684-.875c.419-1.688 1.594-2.823 2.923-2.823s2.5 1.134 2.924 2.823a.705.705 0 01-1.368.34c-.256-1.032-.9-1.752-1.556-1.752s-1.3.721-1.555 1.753a.705.705 0 01-.684.534z","fill":"#664100"}})])])])])
          )
        }
      }
    